import React, { useState } from 'react';
import { HeartIcon, ShareIcon, ZoomInIcon } from 'lucide-react';
import { SmartImage } from '../shared/SmartImage';
interface ProductImageGalleryProps {
  images: string[];
  productName: string;
  discount?: number;
  prescriptionNeeded?: boolean;
}
export function ProductImageGallery({
  images,
  productName,
  discount,
  prescriptionNeeded
}: ProductImageGalleryProps) {
  const [selectedImage, setSelectedImage] = useState(0);
  return <div className="space-y-4" data-id="element-5263" data-mp="29na7h63mm18r">
      {/* Main Image - aspect-square */}
      <div className="relative aspect-square bg-white border border-gray-200 rounded-lg overflow-hidden group" data-id="element-5264" data-mp="25iu6nj8vdk0e">
        <SmartImage src={images[selectedImage]} alt={productName} aspectRatio="aspect-square" className="transition-transform duration-300 group-hover:scale-110" data-id="element-5265" data-mp="2jiloxw6f5mk7" />
        {/* Discount Badge */}
        {discount && discount > 0 && <div className="absolute top-3 left-3 bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full z-10" data-id="element-5266" data-mp="k7ki2uuglmqd">
            -{discount}%
          </div>}
        {/* Action Buttons */}
        <div className="absolute top-3 right-3 flex flex-col gap-2 z-10" data-id="element-5267" data-mp="ybqmu76e9286">
          <button className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1E2B55]" data-id="element-5268" data-mp="12cakrcysk9vd">
            <HeartIcon className="w-5 h-5 text-gray-700" data-id="element-5269" data-mp="1c2c822jblo98" />
          </button>
          <button className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1E2B55]" data-id="element-5270" data-mp="1c4gbykh7yn9i">
            <ShareIcon className="w-5 h-5 text-gray-700" data-id="element-5271" data-mp="1m11ija8w06fg" />
          </button>
          <button className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1E2B55]" data-id="element-5272" data-mp="1q2emfesf5zjq">
            <ZoomInIcon className="w-5 h-5 text-gray-700" data-id="element-5273" data-mp="3rt890m0trh18" />
          </button>
        </div>
        {/* Hover to Zoom Text */}
        <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-60 text-white text-xs px-3 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-5274" data-mp="yy85mehw0zwb">
          Hover to zoom
        </div>
        {/* Prescription Badge */}
        {prescriptionNeeded && <div className="absolute bottom-3 left-3 bg-red-100 text-red-700 text-xs font-medium px-3 py-1 rounded-full border border-red-300" data-id="element-5275" data-mp="13wjealwg54cy">
            Prescription needed
          </div>}
      </div>
      {/* Thumbnail Images - 4-6 items */}
      <div className="grid grid-cols-4 md:grid-cols-6 gap-2" data-id="element-5276" data-mp="1ro6w8ebqd533">
        {images.map((image, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`aspect-square rounded-md border-2 overflow-hidden transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1E2B55] ${selectedImage === index ? 'border-[#1E2B55]' : 'border-gray-200 hover:border-gray-300'}`} aria-label={`View image ${index + 1} of ${images.length}`} data-id="element-5277" data-mp="1mo2g4peqicde" data-mpi={index}>
            <img src={image} alt={`${productName} thumbnail ${index + 1}`} className="w-full h-full object-cover bg-gray-50" data-id="element-5278" data-mp="2k8u8jh4nn6mv" />
          </button>)}
      </div>
    </div>;
}